(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ltp-frame-swatch-options"] && !Shopify.designMode) return;
  try {
    document.documentElement.dataset.ltpFrameInput = 'pointer';

  document.addEventListener('keydown', (event) => {
    if (event.isTrusted) document.documentElement.dataset.ltpFrameInput = 'keyboard';
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.isTrusted) document.documentElement.dataset.ltpFrameInput = 'pointer';
  }, true);
  } catch(e) { console.error(e); }
})();

})();
